import styled from 'styled-components';

export const HeaderCell = styled.th`
  touch-action: none;
  user-select: none;
`;
